import { useFormik } from "formik";
import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import callApi from "services/api";
import { setAlertMessage } from "state/slices/alertSlice";
import { selectLoading, setLoading } from "state/slices/loaderSlice";
import { setLoginView } from "state/slices/loginViewSlice";
import { generateES6Hash } from "utils/Encryption";
import * as Yup from "yup";
import { selectResetData, clearResetData } from "state/slices/resetPasswordSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const ResetPassword = () => {
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { username, token } = useSelector(selectResetData);
  console.log("ResetPassword - username:", username);
  console.log("ResetPassword - token:", token);
  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },

    validationSchema: Yup.object({
      password: Yup.string()
        .required("Please provide your password to proceed.")
        .min(8, "Password must be at least 8 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
          "Password must contain at least one uppercase letter, one lowercase letter, and one number"
        ),
      confirmPassword: Yup.string()
        .required("Please confirm your password")
        .oneOf([Yup.ref("password"), null], "Passwords must match"),
    }),
    onSubmit: async (values) => {
      // Here you would typically handle the password reset logic
      // For now, we'll just log the values
      console.log("Password reset submitted:", values);
      const obj = {
        username,
        token,
        newPassword: generateES6Hash(values.password),
        confirmPassword: generateES6Hash(values.confirmPassword),
      };
      await resetPassword(obj);
    },
  });

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      formik.handleSubmit();
    }
  };

  const resetPassword = async (obj) => {
    dispatch(setLoading(true));

    const response = await callApi(
      `/reset-password`,
      "POST",
      obj,
      true,
      false,
      dispatch,
      navigate
    );

    if (response?.success) {
      dispatch(
        setAlertMessage("Password reset successfully. Please login.|true")
      );
      dispatch(setLoginView("login"));
      dispatch(clearResetData());
      navigate("/");
    } else {
      // show error
    }

    dispatch(setLoading(false));
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card mt-3">
            <div className="card-face card-front">
              <div className="card-body">
                <div className="text-center mb-2">
                  <b className="card-title">Reset Password</b>
                </div>

                <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      New Password:<span className="text-danger">*</span>
                    </label>
                    <div className="position-relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        name="password"
                        className={`form-control ${formik.touched.password && formik.errors.password
                          ? "is-invalid"
                          : ""
                          }`}
                        {...formik.getFieldProps("password")}
                        placeholder="Enter Password"
                        maxLength={50}
                      />
                      <span
                        className="position-absolute top-50 end-0 translate-middle-y"
                        onClick={() => setShowPassword((prev) => !prev)}
                        style={{
                          cursor: "pointer",
                          marginRight: formik.errors.password
                            ? "1.99rem"
                            : "1rem",
                        }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                    {formik.touched.password && formik.errors.password && (
                      <div
                        style={{
                          color: "#f03d3d",
                          fontSize: "0.75rem",
                          marginTop: "0.375rem",
                        }}
                      >
                        {formik.errors.password}
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="confirmPassword" className="form-label">
                      Confirm Password:<span className="text-danger">*</span>
                    </label>
                    <div className="position-relative">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        id="confirmPassword"
                        name="confirmPassword"
                        className={`form-control ${formik.touched.confirmPassword &&
                          formik.errors.confirmPassword
                          ? "is-invalid"
                          : ""
                          }`}
                        {...formik.getFieldProps("confirmPassword")}
                        placeholder="Confirm Password"
                        maxLength={50}
                      />
                      <span
                        className="position-absolute top-50 end-0 translate-middle-y"
                        onClick={() => setShowConfirmPassword((prev) => !prev)}
                        style={{
                          cursor: "pointer",
                          marginRight: formik.errors.confirmPassword
                            ? "1.99rem"
                            : "1rem",
                        }}
                      >
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                    {formik.touched.confirmPassword &&
                      formik.errors.confirmPassword && (
                        <div
                          style={{
                            color: "#f03d3d",
                            fontSize: "0.75rem",
                            marginTop: "0.375rem",
                          }}
                        >
                          {formik.errors.confirmPassword}
                        </div>
                      )}
                  </div>

                  <div className="d-flex justify-content-center">
                    <button className="btn btn-info w-100" disabled={loading}>
                      Reset
                    </button>
                  </div>
                </form>
                <div className="d-flex justify-content-center mt-3">
                  <button
                    className="btn btn-link"
                    onClick={() => dispatch(setLoginView("login"))}
                  >
                    <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
